import * as React from "react";

import { UitkCardAlohaContentSection } from "uitk-react-cards";
import { UitkSpacing } from "uitk-react-spacing";

import DescriptionAndGuestReviewSection from "./DescriptionAndGuestReviewSection";

import { DescriptionAndGuestReviewSectionProps } from "components/flexComponents/Packages/typings";

const DescriptionAndGuestReviewSectionWrapper: React.FC<DescriptionAndGuestReviewSectionProps> = ({
  packageItem,
  language,
  renderReviewRating,
  marginOnTop,
}) => {
  const isDescriptionEmpty =
    !packageItem.hotelDescription &&
    !packageItem.showHotelGuestRating &&
    !(packageItem.showHotelReview && packageItem.hotelReviewSample !== null && packageItem.hotelReviewSample !== "");
  if (isDescriptionEmpty) {
    return null;
  }

  return (
    <UitkSpacing padding={{ blockstart: "three" }}>
      <UitkCardAlohaContentSection border="top" padded={false}>
        <DescriptionAndGuestReviewSection
          packageItem={packageItem}
          language={language}
          renderReviewRating={renderReviewRating}
          marginOnTop={marginOnTop}
        />
      </UitkCardAlohaContentSection>
    </UitkSpacing>
  );
};

export default DescriptionAndGuestReviewSectionWrapper;
